import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from 'ngx-flexible-layout';

import { MaterialModule } from '@app/material.module';

import { ShellComponent } from './shell.component';
import { HeaderComponent } from './header/header.component';
import { SharedModule } from '@app/shared/shared.module';
import { NotificationsModule } from '@app/notifications/notifications.module';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MaterialModule,
    RouterModule,
    SharedModule,
    NotificationsModule,
    TourMatMenuModule,
  ],
  declarations: [HeaderComponent, ShellComponent],
})
export class ShellModule {}
